// import { NavLink } from "react-router-dom";
// import "./SalesTabs.css";

// const tabs = [
//   { name: "Snakes", path: "/layout/snake" },
//   { name: "Background", path: "/layout/background" },
//   { name: "Power-ups", path: "/layout/powerup" },
// ];

// const SalesTabs = () => {
//   return (
//     <div className="sales-tabs">
//       {tabs.map((tab) => (
//         <NavLink
//           key={tab.name}
//           to={tab.path}
//           className={({ isActive }) =>
//             `sales-tab ${isActive ? "active" : ""}`
//           }
//         >
//           {tab.name}
//         </NavLink>
//       ))}
//     </div>
//   );
// };

// export default SalesTabs;

import "./SalesTabs.css";

const TABS = ["snake", "background", "powerup", "chest"];

export default function SalesTabs({ activeTab, onTabChange }) {
  return (
    <div className="sales-tabs">
      {TABS.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          className={`sales-tab ${activeTab === tab ? "active" : ""}`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
